module.exports = __webpack_public_path__ + "img/Walker.7cbac60e.jpg";